/**
 * Owner: Masa Bayu
 * File: pwa-foundation.ts
 * Date:Time: 2026-09-15 19:18
 * Description: QXRead T0 PWA foundation states — install ≠ content unlock.
 */
export const QXREAD_INSTALL_STATES = ['unknown', 'promptable', 'installed', 'blocked'];
export const QXREAD_OFFLINE_PACKAGE_STATES = [
    'not_prepared',
    'preparing',
    'ready',
    'stale',
    'purge_pending',
    'purged',
    'prepare_denied',
];
/**
 * Installable shell is allowed; it never grants publication access.
 */
export function createQxreadPwaFoundation(options = {}) {
    const installState = options.installState ?? 'unknown';
    const offlinePackageState = options.offlinePackageState ?? 'not_prepared';
    if (!QXREAD_INSTALL_STATES.includes(installState)) {
        throw new Error('QXRead installState is unknown');
    }
    if (!QXREAD_OFFLINE_PACKAGE_STATES.includes(offlinePackageState)) {
        throw new Error('QXRead offlinePackageState is unknown');
    }
    return Object.freeze({ installState, offlinePackageState });
}
/** Offline prepare requires active entitlement — foundation policy check. */
export function canPrepareOffline(input) {
    if (!input.entitlementActive) {
        return Object.freeze({
            allowed: false,
            reason: 'Offline preparation denied without active entitlement',
        });
    }
    if (input.installState === 'blocked') {
        return Object.freeze({
            allowed: false,
            reason: 'PWA install blocked — offline prepare unavailable',
        });
    }
    return Object.freeze({
        allowed: true,
        reason: 'Offline preparation permitted under active entitlement',
    });
}
//# sourceMappingURL=pwa-foundation.js.map